"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EProjectReason = void 0;
const enum_1 = require("../../utils/enum");
exports.EProjectReason = (0, enum_1.strEnum)(["PROTECT", "PROTECT_AND_DEVELOPMENT_AID"]);
